<p-panel class="our-form-background">
  <ng-template pTemplate="header" class="eca-secondary-bg" style="color: white">
    <div class="col">
      <h3 style="margin-bottom: 0 !important;">
        <span style="margin-left: 15px;">
          <span class="hide-on-small-screens"> Company Settings</span>
        </span>
      </h3>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="container-fluid" style="margin-top: 1rem; margin-bottom: 200px; min-height: 400px">
      <div class="row">
        <div class="col">
          <p-tabView #memberTabs [styleClass]="'eca-tabs'">
            <p-tabPanel>
              <ng-template pTemplate="header">
                <i class='fas fa-file'></i>
                <span class="tab-title">Alert Settings</span>
              </ng-template>
              <div class="row">
                <div class="col-12">
                  <app-company-alerts-settings>
                  </app-company-alerts-settings>
                </div>
              </div>
            </p-tabPanel>

            <p-tabPanel>
              <ng-template pTemplate="header">
                <i class='fas fa-file'></i>
                <span class="tab-title">Job Roles</span>
              </ng-template>
              <div class="row">
                <div class="col-12">
                  <app-job-role-list [showHeaderText]="true" (addCompanyJobRoleRequested)="addNewCompanyJobRole()"
                                     (refreshCompanyJobTitleSuggested)="getAllCompanyJobTitles()"
                                     (deleteCompanyJobTitleRequested)="deleteCompanyJobTitle($event)"
                                     [companyJobTitles]="companyJobTitles"
                                     [addButtonText]="'Add New Job Role'">
                  </app-job-role-list>
                </div>
              </div>
            </p-tabPanel>
            <!--Business Units-->
            <p-tabPanel>
              <ng-template pTemplate="header">
                <i class='fas fa-file'></i>
                <span class="tab-title">My Business Units</span>
              </ng-template>
              <div class="row">
                <div class="col-12">
                  <app-business-unit-list></app-business-unit-list>
                </div>
              </div>
            </p-tabPanel>
          </p-tabView>
        </div>
      </div>
    </div>
  </ng-template>
</p-panel>
